export default __webpack_public_path__ + "static/media/itch_white@4x.f286a34b.png";